
import React from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw } from "lucide-react";

interface MovieErrorRetryProps {
  error: string;
  onRetry: () => void;
  title?: string;
  className?: string;
}

const MovieErrorRetry: React.FC<MovieErrorRetryProps> = ({
  error,
  onRetry,
  title = "Failed to load movie",
  className = ""
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-6 ${className}`}>
      <AlertCircle className="w-12 h-12 text-red-500 mb-4" />
      <h3 className="text-lg font-semibold text-mono-eerieBlack mb-2">{title}</h3>
      <p className="text-mono-onyx/70 text-center mb-4 max-w-md">
        {error}
      </p>
      <Button 
        onClick={onRetry}
        variant="outline"
        className="flex items-center gap-2"
      >
        <RefreshCw className="w-4 h-4" />
        Try Again
      </Button>
    </div>
  );
};

export default MovieErrorRetry;
